import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";

import ImageBox from "../../../../ui/InfoDrawer/components/ImageBox";
import Title from "../../../../ui/InfoDrawer/components/Title";
import InfoField from "../../../../ui/InfoDrawer/components/InfoField";
import InfoBox from "../../../../ui/InfoDrawer/components/InfoBox";
import Button from "../../../../ui/Button";
import Progress from "../../../../ui/Progress";

import { getModuleCardAction } from "../../store/actions";

const useStyles = makeStyles({
  progress: {
    display: "flex",
    justifyContent: "center"
  },
  constructorButton: {
    marginTop: 15,
    display: "flex",
    justifyContent: "center",

    "& button": {
      fontSize: "12px",
      fontWeight: "600"
    }
  }
});

const ModuleInfoDrawer = ({
  moduleId,
  moduleCard,
  getModuleCard,
  history,
  newModule
}) => {
  const classes = useStyles();
  React.useEffect(() => {
    if (moduleId !== -1 && !newModule) {
      getModuleCard(moduleId);
    }
  }, [getModuleCard, moduleId, newModule]);
  const editModuleClick = () => {
    history.push(`/work/app/constructor/edit-module/${moduleId}`);
  };

  return (
    <div>
      {moduleCard ? (
        <div>
          <ImageBox type="module" image={moduleCard.logo} />
          <Title item={moduleCard} type="module" />
          <InfoField
            name="Профессия"
            value={
              moduleCard && moduleCard.speciality && moduleCard.speciality.name
            }
          />
          <InfoField
            name="Компетенция"
            value={
              moduleCard.skill && moduleCard.skill && moduleCard.skill.name
            }
          />
          <InfoField
            name="Форма обучения"
            value={moduleCard.educationForm && moduleCard.educationForm.name}
          />
          <InfoField
            name="Форма аттестации"
            value={moduleCard.trialForm && moduleCard.trialForm.name}
          />
          <InfoBox
            title="Организация"
            image={moduleCard.organization && moduleCard.organization.logo}
            desc={moduleCard.organization && moduleCard.organization.name}
          />
          <InfoField name="СОСТАВИТЕЛИ" />
          {moduleCard &&
            moduleCard.authors.map(item => (
              <InfoBox
                key={item.id}
                name={item.name}
                image={item.avatar}
                desc={item.post}
              />
            ))}
          {!newModule && (
            <div className={classes.constructorButton}>
              <Button onClick={editModuleClick}>ОТКРЫТЬ КОНСТРУКТОР</Button>
            </div>
          )}
        </div>
      ) : (
        <div className={classes.progress}>
          <Progress />
        </div>
      )}
    </div>
  );
};

const mapStateToProps = state => ({
  moduleCard: state.modules.moduleCard
});

const mapDispatchToProps = dispatch => ({
  getModuleCard: id => dispatch(getModuleCardAction(id))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ModuleInfoDrawer));
